import './date_filter_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ModerationDateFilterView extends Monitoring.Views.SocialContents.Filters.DateFilterView

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet
    @title = I18n.t('monitoring.dashboard.filters.filter_names.moderation_time')
    @filtersContainer = @options.filtersContainer

  prefix: ->
    'moderation_date'

  render: ->
    @$el.html(@template(currentDate: @currentDate(), viewId: @cid, title: @title))
    @_renderDatePicker()
    @$el.find('.radio').on('click', @_handleRadioButtons)

    if @searchQuery.get('moderation_date_from_realtime')
      realtimeValue = @searchQuery.get('moderation_date_from_realtime').value
      realtimeValue = '1576800' if realtimeValue == 'all_history' # legacy sessions: select "Last three years"
      @$el.find("#realtime_cbo option[value=#{realtimeValue}]").prop('selected', true)
    else if @searchQuery.hasEspecificModerationTime()
      @$el.find('.timerange').get(0).checked = true
      @$el.find('.realtime').get(0).checked = false
      @$el.find('.datepicker.from').datepicker().data('datepicker').setDate(new Date(@searchQuery.get('moderation_date_from_ISO')))
      @$el.find("#from_time option[value=\"#{new Date(@searchQuery.get('moderation_date_from_ISO')).toTimeString().substring(0,5)}\"]").prop('selected', true)
      if @searchQuery.get('moderation_date_now')
        @enableNowCheck()
        @_onNowChangeManual()
      else
        @$el.find('.datepicker.to').datepicker().data('datepicker').setDate(new Date(@searchQuery.get('moderation_date_to_ISO')))
        @$el.find("#to_time option[value=\"#{new Date(@searchQuery.get('moderation_date_to_ISO')).toTimeString().substring(0,5)}\"]").prop('selected', true)

    @_handleRadioButtons()
    return this

  _addDate: =>
    dateFrom =  ""
    realtime = @$el.find('.realtime').get(0).checked
    now = true

    # Reset date filters
    @searchQuery.removeModerationDateTo()
    @searchQuery.removeModerationDateFrom()
    @searchQuery.setModerationNowDate(false)
    @searchQuery.removeModerationDateFromRealtime()

    if realtime
      select = @$el.find('#realtime_cbo')
      @searchQuery.addModerationDateFromRealtime(
        value: select.val()
        name: select.find('option:selected').text()
      )
    else
      dateFrom = @$el.find('#from').val() + ' ' + @$el.find('#from_time').val()
      dateTo = @$el.find('#to').val() + ' ' + @$el.find('#to_time').val()
      now = @isNowChecked()
      @searchQuery.addModerationDateTo(dateTo = Date.create(dateTo + Date.browserTimeZoneString(), 'DD/MM/YYYY HH:mm ZZ'), prefix = @prefix()) unless now
      @searchQuery.addModerationDateFrom(dateFrom = Date.create(dateFrom + Date.browserTimeZoneString(), 'DD/MM/YYYY HH:mm ZZ'), prefix = @prefix())
      @searchQuery.setModerationNowDate(now, @prefix())

    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
